import { useQuery } from '@tanstack/react-query';
import { fetchPlanVehicleRules } from '../services/planVehicleRules';

export const planVehicleRulesQueryKey = (planId: string) => ['smr-admin', 'plan-vehicle-rules', planId];

export function usePlanVehicleRulesQuery(planId: string) {
    return useQuery({
        queryKey: planVehicleRulesQueryKey(planId),
        queryFn: () => fetchPlanVehicleRules(planId),
        enabled: Boolean(planId),
    });
}
